import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe, Location } from '@angular/common';
import {ToastrService} from 'ngx-toastr';


@Component({
  selector: 'app-list-vehicle',
  templateUrl: './list-vehicle.component.html',
  styleUrls: ['./list-vehicle.component.scss']
})
export class ListVehicleComponent implements OnInit {
  p: number = 1;
  itemsPerPage : number = 10;
  userRecord!: any[];
  seachText: any;
  userRecordData: any[] | undefined;
  states!: any[];
  selectedState!:any;
  role:any;
  state_name!: any;
  intanglesToken:any;

  
  StateRecord: any[] | undefined;
  [x: string]: any;

  addVehicleForm!: FormGroup;
  submitted = false;
  success = false;
  isReadMode = true;
  isUpdateMode = false;
  isDeleteMode = false;
  fromDate !: any;
  endDate !: any;
  stateCode !: any;
  userId!: any;
  
  

  constructor(private formBuilder: FormBuilder, private router: Router, private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService, private route: ActivatedRoute, private toastr: ToastrService, private location: Location
    // , private alertService: AlertService
  ) { 
    //this.registerVehicle.getVehicleDetail().subscribe((data: Vehicle[]) =>{
      //console.log(data);
      //this.userRecord = data;
      //this.userRecordData = data;
    //})
  }

  ngOnInit(): void {
    this.role = this.authService.getRole();
 
    this.route.params.subscribe(params => {
      this.stateCode = params['stateCode']; // (+) converts string 'id' to a number
    });
    debugger;
    this.addVehicleForm = this.formBuilder.group({
      stateCode: ['', Validators.required],
      userId: [''],
      userName: [''],
      roles: [''],
      designation: [''],
      emailId: ['', Validators.required],
      mobileNo: ['', Validators.required],
      chasisNo: ['', Validators.required],
      city:[''],
      vehicleNo: ['', Validators.required]
      // mobileNo: ['', [Validators.required, Validators.pattern("^[0-9]{10}$")]]

    })
   
    this.bindState();

    if(this.stateCode)
    {
      this.getVehicleListByStateCode(this.stateCode);
    }
    else
    {
      this.getVehicleData();
    }

    setTimeout(() => {
      this.spinnerService.hide();
    }, 1000);
    
  }
  get f(): { [key: string]: AbstractControl } {
    return this.addVehicleForm.controls;
  }

  getVehicleData(): void{
    this.spinnerService.show();
    this.fswService.getVehicleDetail().subscribe((data: any[]) =>{
      console.log(data);
      this.userRecord = data;
      this.userRecordData = data;
      this.spinnerService.hide();
    })

  }
  bindState(): void{
    this.fswService.getState().subscribe((data: any[]) =>{
      console.log(data);
      this.states = data;
      this.StateRecord = data;
     // this.userRecordData = data;
    })

  }

 search() {
      console.log(this.seachText);
      this.p=1;
      this.spinnerService.show();
      let filteredData=this.userRecord;
      if(this.seachText != undefined && this.seachText != ""){
        filteredData = filteredData.filter(m => (m.vehicleNo.indexOf(this.seachText)>-1));
        
      }
      if(this.fromDate != undefined && this.endDate != undefined && this.fromDate!=""&&this.endDate!="")
      {
        debugger
      // var d1 = new Date(this.fromDate);
       //var d2 = new Date(this.endDate);
       /* var startDate = this.fromDate.split("-");
       var d1 = startDate[2] + '/' + startDate[1] + '/' + startDate[0];
       var toDate = this.endDate.split("-");
       var d2 = toDate[2] + '/' + toDate[1] + '/' + toDate[0]; */
       if(this.seachText!=undefined && this.seachText!="")
       {
       var datePipe = new DatePipe("en-US");
        
        filteredData = filteredData.filter(m =>{
          var testingDate = new Date(datePipe.transform(new Date(m.createdOn), 'yyyy-MM-dd'));
          var d1 = new Date(datePipe.transform(new Date(this.fromDate), 'yyyy-MM-dd'));
          var d2 = new Date(datePipe.transform(new Date(this.endDate), 'yyyy-MM-dd')); 
          if((testingDate>=d1) && (testingDate<=d2)&& m.vehicleNo.indexOf(this.seachText)>-1)
          {
            return m;
          }
          
        })
      }
      else
      {
        var datePipe = new DatePipe("en-US");
        
        filteredData = filteredData.filter(m =>{
          var testingDate = new Date(datePipe.transform(new Date(m.createdOn), 'yyyy-MM-dd'));
          var d1 = new Date(datePipe.transform(new Date(this.fromDate), 'yyyy-MM-dd'));
          var d2 = new Date(datePipe.transform(new Date(this.endDate), 'yyyy-MM-dd')); 
          if((testingDate>=d1) && (testingDate<=d2))
          {
            return m;
          }
          
        })
      }
      }
      else
      {
        if((this.fromDate==undefined || this.fromDate=="") && (this.endDate==undefined|| this.endDate=="") && (this.seachText==undefined||this.seachText==""))
        {
          this.toastr.error('Please provide search value');
        }

        else if ((this.seachText != undefined && this.seachText != ""))
        {
          if((this.fromDate==undefined||this.fromDate=="")&&(this.endDate!=undefined &&this.endDate!="")) 
          {
            this.toastr.error('Please provide both from Date and end Date');
          }
          if((this.fromDate!=undefined&&this.fromDate!="")&&(this.endDate==undefined||this.endDate=="")) 
          {
            this.toastr.error('Please provide both from Date and end Date');
          }
          
        }
        else
        {

          this.toastr.error('Please provide both from Date and end Date');
        }
      
      }
      //Previous incorrect filtering code commented 05-07-2022
      // if(this.selectedState != undefined){
      //   filteredData = filteredData.filter(m => (m.stateCode == this.selectedState));
         
      // }
        // if(this.fromDate != undefined && this.endDate != undefined)
        // {
        //   debugger
        // // var d1 = new Date(this.fromDate);
        // // var d2 = new Date(this.endDate);
        //  /* var startDate = this.fromDate.split("-");
        //  var d1 = startDate[2] + '/' + startDate[1] + '/' + startDate[0];
        //  var toDate = this.endDate.split("-");
        //  var d2 = toDate[2] + '/' + toDate[1] + '/' + toDate[0]; */
        //  var datePipe = new DatePipe("en-US");
          
        //   filteredData = filteredData.filter(m =>{
        //     var testingDate = new Date(datePipe.transform(new Date(m.createdOn), 'yyyy-MM-dd'));
        //     var d1 = new Date(datePipe.transform(new Date(this.fromDate), 'yyyy-MM-dd'));
        //     var d2 = new Date(datePipe.transform(new Date(this.endDate), 'yyyy-MM-dd')); 
        //     if((testingDate>=d1) && (testingDate<=d2))
        //     {
        //       return m;
        //     }
            
        //   })
        // }
  
        this.userRecordData = filteredData;
  
        
        this.spinnerService.hide();
     //return this.testingsRecordData;  
     
      }
    updateRow(x: any) {
      debugger
      // var delBtn = confirm(" Do you want to update ?");
      // if (delBtn == true) {
        this.spinnerService.show();
        this.isDeleteMode = false;
        this.isReadMode = false;
        this.isUpdateMode = true;
        this.bindState();
        this.id = x.id;
        this.selectedState = x.stateCode;
        this.addVehicleForm.controls['vehicleNo'].setValue(x.vehicleNo);
        this.addVehicleForm.controls['chasisNo'].setValue(x.chasisNo);
        this.addVehicleForm.controls['userId'].setValue(x.userId);
        this.addVehicleForm.controls['userName'].setValue(x.userName);
        this.addVehicleForm.controls['stateCode'].setValue(x.stateCode);
        this.addVehicleForm.controls['emailId'].setValue(x.emailId);
        this.addVehicleForm.controls['mobileNo'].setValue(x.mobileNo);
        this.addVehicleForm.controls['designation'].setValue(x.designation);
        this.addVehicleForm.controls['city'].setValue(x.city);
        this.spinnerService.hide();
        //}
    }
    deleteRow(x: any) {
      debugger
       var delBtn = confirm(" Do you want to delete the vehicle?");
       if (delBtn == true) {
         debugger
        this.spinnerService.show();
        this.id = x.id;
        this.userId = x.userId;
        this.vehicleNo = x.vehicleNo;
        this.chasisNo=x.chasisNo;

        this.emailId = x.emailId;
        this.mobileNo = x.mobileNo;
        this.isDeleteMode = true;
        this.isReadMode = false;
        this.isUpdateMode = false;
        
        this.spinnerService.hide();
        }
    }
    onupdateUserSubmit() {
      this.spinnerService.show();
      this.submitted = true;
      debugger
      if (this.addVehicleForm.invalid) {
        return;
      }
      var role = ["ROLE_USER"]
     // this.addUserForm.controls['roles'].setValue(role);
      console.log(this.addVehicleForm.value);
      this.fswService.updateProfileData(this.id, this.addVehicleForm.value)
        .subscribe(
          response => {
            this.submitted = true;
            this.spinnerService.hide();
            this.isReadMode = true;
            this.bindState();
            if(this.stateCode)
            {
              this.getVehicleListByStateCode(this.stateCode);
            }
            else
            {
              this.getVehicleData();
            }
            this.seachText = null;
          },
          error => {
            console.log(error);
            this.spinnerService.hide();
            
          });
  
      this.success = true;
     // this.addVehicleForm.reset({});
    }

    closeAlert() {
      this.success = false;
    }
    getVehicleListByStateCode(stateCode) {
      this.spinnerService.show();
      this.fswService.getVehicleListByState(stateCode)
        .subscribe(res => {
        debugger
        this.userRecord = res;
        this.userRecordData = res;
        this.state_name = res[0].stateName;
        this.spinnerService.hide();        
        });
    }
    ondeleteUserSubmit() {
      console.log(this.adminRemark);
      console.log(this.id);
      this.spinnerService.show();
      var data =
      {
        "userId":this.userId, 
        "adminRemark":this.adminRemark,
        "vehicleNo":this.vehicleNo,
        "chasisNo":this.chasisNo
      }
      debugger;
      console.log(data);
      if(this.adminRemark != undefined && this.adminRemark != ""){
        this.fswService.deleteVehicle(data)
        .subscribe(
          response => {
            this.submitted = true;
            this.spinnerService.hide();
            this.toastr.success('Vehicle Deleted Successfully!');
            this.isReadMode = true;
            this.isDeleteMode = false;
            this.isUpdateMode = false;
            if(this.stateCode)
            {
              this.getVehicleListByStateCode(this.stateCode);
            }
            else
            {
              this.getVehicleData();
            }
            this.adminRemark = null;
            
          },
          error => {
            this.toastr.error('Vehicle Not Deleted!');
            this.spinnerService.hide();
            
          }); 
      }
      else
      {
        this.toastr.error('Please Enter Remark!');
      }
      this.spinnerService.hide();
     }
     
     back(): void {
      this.location.back()
    }
    reset() {
      // window.location.reload();
      this.seachText="";
      this.fromDate="";
      this.endDate="";
      this.ngOnInit();
    }
    trackVehicle(chasisNo: string){
      var data = {
        "external_id": "ae6803d9-cf47-4a12-9c49-9d7c11f365b1",
        "session": "BVm6SOGEKKVrZ0ewx1dd_dDAliDoaocgEqq4gQ_9ySUT0qqOf0zMwGpjRnMyDlCk"
        }
     this.fswService.getVehicleTokenFromIntangles(data)
      .subscribe(response => {
        this.intanglesToken = response.status.token //'BVm6SOGEKKVrZ0ewx1dd_dDAliDoaocgEqq4gQ_9ySUT0qqOf0zMwGpjRnMyDlCk'//response.token;
        window.open('https://inroute.intangles.com/?vehicle='+chasisNo+'&token='+this.intanglesToken)
      })

    }

}
